import z from 'zod';
import { paymentReferenceValue } from '../../payment/value-objects/payment-reference';
import { capabilityValue } from '../../shared/capabilities';
import { firmIdValue } from '../value-objects/ids';
import { stripePriceLookupKeyValue, stripeProductIdValue, } from '../value-objects/stripe-ids';
import { firmTypologyValue } from '../value-objects/subscription-enums';
import { firmBillingProfileSnapshotSchema } from './firm-billing-profile-snapshot';
import { firmUsersSchema } from './firm-user';
import { resolvedSubscriptionProductSchema } from './resolved-subscription-product';
export const firmPendingCheckoutSchema = z.object({
    checkoutSessionReference: paymentReferenceValue.optional(),
    checkoutStartedAt: z.date().optional(),
    checkoutUrl: z.string().optional(),
    expiresAt: z.date(),
    resolvedProduct: resolvedSubscriptionProductSchema,
    stripePriceLookupKey: stripePriceLookupKeyValue,
    stripeProductId: stripeProductIdValue,
});
export const firmPendingCheckoutsSchema = z.array(firmPendingCheckoutSchema);
export const firmSchema = z.object({
    acceptedTermsVersion: z.number(),
    billingProfile: firmBillingProfileSnapshotSchema.optional(),
    contactEmail: z.string(),
    createdAt: z.date(),
    id: firmIdValue,
    name: z.string(),
    overrideBotRequestLimit: z.number().min(0).optional(),
    overrideCapabilities: z.array(capabilityValue).default([]),
    overrideLawerConsultationFees: z.number().min(0).optional(),
    pendingCheckout: firmPendingCheckoutSchema.optional(),
    typology: firmTypologyValue.optional(),
    users: firmUsersSchema.optional(),
});
export const firmsSchema = z.array(firmSchema);
//# sourceMappingURL=firm.js.map